<template>
  <div>
    <div
      v-for="localBoundingBox in orderedBoundingBoxes"
      :key="`${localBoundingBox.top}, ${localBoundingBox.left}`"
    >
      <div class="left-line" :style="getLeftLineStyle(localBoundingBox)" />
    </div>
    <div
      v-for="localBoundingBox in orderedBoundingBoxes"
      :key="`${localBoundingBox.top}, ${localBoundingBox.left}`"
      class="alignment-indicator"
      :style="getAlignmentIndicators(localBoundingBox)"
    >
      <div class="horizontal-line" :style="getHorizontalLineStyle()" />
    </div>
  </div>
</template>

<script>
import { FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA } from '@/constants/colors';
import { rgbToHex } from '@/utils/color';

export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    boundingBoxes: {
      type: Array,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  computed: {
    left() {
      return -Math.min(this.boundingBox.left - 2, 50 * this.zoomFactor);
    },
    baseWidth() {
      return Math.max(5, -10 - this.left);
    },
    orderedBoundingBoxes() {
      return [...this.boundingBoxes].sort((a, b) => {
        return a.top - b.top;
      });
    },
    // Computes the vertical midpoints between each of the lines of text, to be used for colour coding.
    midpoints() {
      const midpoints = [0];
      for (let i = 0; i < this.orderedBoundingBoxes.length - 1; i++) {
        const boundingBox = this.orderedBoundingBoxes[i];
        const next = this.orderedBoundingBoxes[i + 1];
        const bottom = boundingBox.top + boundingBox.height;
        const next_top = next.top;
        let midpoint = (bottom + next_top) / 2;
        midpoint -= this.boundingBox.top;
        midpoints.push(midpoint);
      }
      midpoints.push(this.boundingBox.height);
      return midpoints;
    },
  },
  methods: {
    getHorizontalLineStyle() {
      return {
        background: FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
      };
    },
    getLeftLineStyle(localBoundingBox) {
      const i = this.orderedBoundingBoxes.indexOf(localBoundingBox);
      const top = this.midpoints[i];
      const height = this.midpoints[i + 1] - top;
      return {
        top: `${top}px`,
        left: `${this.left}px`,
        height: `${height}px`,
        background: FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA,
      };
    },
    getAlignmentIndicators(localBoundingBox) {
      const color = FRAUD_SIGNAL_BOUNDING_BOX_COLOR_RGBA;
      return {
        height: `${localBoundingBox.height}px`,
        top: `${localBoundingBox.top - this.boundingBox.top}px`,
        width: `${
          (localBoundingBox.left - this.boundingBox.left) * this.zoomFactor +
          this.baseWidth
        }px`,
        left: `${this.left}px`,
        borderColor: color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.alignment-indicator {
  position: absolute;
  display: flex;
  justify-content: left;
  align-items: center;
  border-style: solid;
  border-width: 0 2px 0 0;
}

.horizontal-line {
  height: 2px;
  width: 100%;
}
.left-line {
  width: 2px;
  position: absolute;
}
</style>
